import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconRemove$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconRemove extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4a6dd07cfa362d81bc351cefe6808809fafb8f1b', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '3000c2471867690b78068928e22e53da94bf7701', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8d4a517400996cb64e1c28e5c54cd4ace1c369bc', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 2a9 9 0 1 0 9 9 9.01 9.01 0 0 0-9-9m0 1.5a7.5 7.5 0 1 1 0 15 7.5 7.5 0 0 1 0-15m-4.5 6.75a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5z", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-remove", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-remove"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-remove":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconRemove$1);
            }
            break;
    } });
}

const CosmosIconRemove = CosmosIconRemove$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconRemove, defineCustomElement };
